import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplateWebhookService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  listar(filtros, config): Observable<any> {
    this.httpOptions.params = config;
    return this.http.post(`${this.apiUrl}api/webhook/listar`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  criar(payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/webhook/criacao`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizar(webhook_id, payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.put(`${this.apiUrl}api/webhook/${webhook_id}`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletar(payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.request('delete', `${this.apiUrl}api/webhook/remover`, {
      body: payload,
      ...this.httpOptions
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  obtem(template_id: number): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/webhook/${template_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownMetodos(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/webhook/dropdown-metodos`, null, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownMacros(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/webhook/dropdown-macros`, null, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownTemplates(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/webhook/dropdown-webhook`, null, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error.message);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é: ${error.error.error_msg}`);
    }
    return throwError(
      error.error);
  }
}
